import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/style/rest.css'
import '@/assets/style/index.css'
import { getToken } from "@/utils/auth.js";
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/style/index.scss'
Vue.use(Vant);
Vue.config.productionTip = false
const whiteList = ['/login', '/notbegin', '/close', '/ends', '/home', '/password']
router.beforeEach((to, from, next) => {
  if (getToken()) {
      next();
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next("/login"); // 否则全部重定向到登录页
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
